//页底处理，上报数据之类的
import Aptracker from "./aptracker";
class Footer{
    constructor(props){
        this.init(props)
    }
    init(props){
        setTimeout(function() {
            Aptracker.collection();
        }, 800);
    }
}
export default Footer;